import { clsx, type ClassValue } from "clsx";
import bigDecimal from "js-big-decimal";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function prettyFixedAmount(amount: string | number) {
  return new bigDecimal(bigDecimal.round(amount, 2)).getPrettyValue();
}
